module.exports = __webpack_public_path__ + "static/elderly-couple-dancing.0ea0923d.jpg";